import Vue from "vue";
import Router from "vue-router";
// import Layout from "@/Layout";

Vue.use(Router);

// Base Routes
export const constantRouterMap = [
  // {
  //   path: "/",
  //   component: Layout,
  //   redirect: "/users",
  //   children: [
  //     {
  //       path: "/users",
  //       component: () => import("@/views/users"),
  //       name: "Users",
  //       meta: {
  //         icon: "mdi-view-dashboard",
  //         title: "users"
  //       }
  //     }
  //   ]
  // },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    meta: {
      title: "login"
    }
  },
  {
    path: "/401",
    component: () => import("@/views/errorPage/401"),
    name: "Page401",
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    name: "Page404",
    hidden: true,
    meta: {
      title: "page_not_found"
    }
  }
];

export default new Router({
  mode: "history",
  //   base: process.env.BASE_URL,
  routes: constantRouterMap
});
